/**
 * Entidad que representa las jornadas de la institución
 */
export type Day = 'V' | 'D';

/**
 * Entidad que representa las jornadas pero con nombre completo
 */
export type DayName = 'vespertino' | 'diurno';

/**
 * Mapa de relaciones que muestra cada jornada con su etiqueta
 */
export const dayLabels: Record<Day, DayName> = {
  V: 'vespertino',
  D: 'diurno',
};

/**
 * Mapa de relaciones que muestra cada jornada con su Key
 */
export const dayKey: Record<DayName, Day> = {
  vespertino: 'V',
  diurno: 'D',
};

/**
 * Entidad que representa los semestres considerados por año
 */
export type SemesterKey = 'semestre-1' | 'semestre-2';

/**
 * Tipo para las etiquetas UI de los semestres
 */
export type SemesterLabel = 'Semestre 1' | 'Semestre 2';

/**
 * Mapa de relaciones que muestra cada semestre con su etiqueta UI
 */
export const semesterLabels: Record<SemesterKey, SemesterLabel> = {
  'semestre-1': 'Semestre 1',
  'semestre-2': 'Semestre 2',
};

/**
 * Mapa de relaciones que muestra cada etiqueta UI con su SemesterKey
 */
export const semesterKeys: Record<SemesterLabel, SemesterKey> = {
  'Semestre 1': 'semestre-1',
  'Semestre 2': 'semestre-2',
};
